<template>
  <div class="ibox float-e-margins">

    <div class="ibox-content content space-loader" :class="{ 'loading': onLoading }">
      <div class="row">
        <div class="col-md-6">
          <h2>Top Gainers</h2>
          <small>The users that win our system at <u>{{ transform(currentDate) }}</u></small>
          <ul class="list-group clear-list m-t">
            <li :class="['list-group-item', { 'fist-item': i === 0 }]" v-for="(ranking, i) in perPage" :key="i">
              <span :class="['label', classMod('positive', ranking)]">{{ ranking }}</span>
              <template v-if="isExists(records, ['stats', 'gainers', i])">
                <span class="pull-right text-green text-numeric">
                  {{ records.stats.gainers[i].amount | number }}
                  <a :href="records.viewpoint + '/member/' + records.stats.gainers[i].user.id + '/bet'"><i class="fa fa-line-chart"></i></a>
                </span>
                <a :href="records.viewpoint + '/member/' + records.stats.gainers[i].user.id + '/show'">
                  {{ records.stats.gainers[i].user.username }} ({{ records.stats.gainers[i].user.firstname }} {{ records.stats.gainers[i].user.lastname }})
                </a>
              </template>
            </li>
          </ul>
        </div>
        <div class="col-md-6">
          <h2>Top Losers </h2>
          <small>The users that lose our system at <u>{{ transform(currentDate) }}</u></small>
          <ul class="list-group clear-list m-t">
            <li :class="['list-group-item', { 'fist-item': i === 0 }]" v-for="(ranking, i) in perPage" :key="i">
              <span :class="['label', classMod('negative', ranking)]">{{ ranking }}</span>
              <template v-if="isExists(records, ['stats', 'losers', i])">
                <span class="pull-right text-red text-numeric">
                  {{ records.stats.losers[i].amount | number }}
                  <a :href="records.viewpoint + '/member/' + records.stats.losers[i].user.id + '/bet'"><i class="fa fa-line-chart"></i></a>
                </span>
                <a :href="records.viewpoint + '/member/' + records.stats.losers[i].user.id + '/show'">
                  {{ records.stats.losers[i].user.username }} ({{ records.stats.losers[i].user.firstname }} {{ records.stats.losers[i].user.lastname }})
                </a>
              </template>
            </li>
          </ul>
        </div>
        <div class="col-md-12">
          <button class="btn btn-xs btn-default pull-left" @click="changeCurrentDate(prevDate)" :disabled="conditionDisablePrev">« {{ transform(prevDate) }}</button>
          <button class="btn btn-xs btn-default pull-right" @click="changeCurrentDate(nextDate)" :disabled="conditionDisableNext">{{ transform(nextDate) }} »</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment-timezone'
  export default {
    name: 'comp-top-users',
    props: {
      userId: {
        type: Number,
        required: true
      },
      perPage: {
        type: Number,
        default: 10
      },
      limitNext: {
        type: Number,
        default: 7
      }
    },
    data () {
      return {
        currentDate: moment().tz("Asia/Bangkok").format('YYYY-MM-DD'),
        onLoading: true,
        records: null
      }
    },
    mounted () {
      // this.getTopUserStats(this.currentDate)
    },
    computed: {
      prevDate () {
        return moment(this.currentDate).subtract(1, 'd')
      },
      nextDate () {
        return moment(this.currentDate).add(1, 'd')
      },
      conditionDisablePrev () {
        const today = moment(new Date())
        return this.onLoading || today.diff(this.prevDate, 'days') === this.limitNext
      },
      conditionDisableNext () {
        const today = moment(new Date()).format('YYYY-MM-DD')
        return this.onLoading || moment(this.nextDate).isAfter(today)
      },
      totalNewMember () {
        return _.get(this.records, 'stats.totalNewMember')
      },
      totalRotationMember () {
        return _.get(this.records, 'stats.totalRotationMember')
      }
    },
    methods: {
      isExists (property, node) {
        return _.has(property, node)
      },
      classMod (type, index) {
        const modOfTypes = {
          positive: ['label-default', 'label-primary', 'label-info'],
          negative: ['label-default', 'label-danger', 'label-warning']
        }
        const mod = index % 3
        return modOfTypes[type][mod]
      },
      getTopUserStats (period = null) {
        this.onLoading = true
        const endpoint = `/users/${this.userId}/game/stats?period=${period}&per_page=${this.perPage}`
        axios.get(endpoint)
          .then((response) => {
            this.records = response.data
            this.onLoading = false
          })
      },
      transform (period) {
        return moment(period).format('DD/MM/YYYY')
      },
      changeCurrentDate (period) {
        this.currentDate = moment(period).format('YYYY-MM-DD')
      }
    },
    watch: {
      currentDate: {
        handler: function (value, old) {
          this.getTopUserStats(value)
        },
        immediate: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/components/TopUsers.vue